<section class="">
  <div class="row mb-2 d-flex justify-content-between container-style">
    <div class="col-12 data-interface">
      <div class="d-flex flex-wrap gap-3 ">
        <div class="d-flex me-1">
          <label class="form-label me-1 style-text">Sucursal:</label>
          <p class="mb-lg-2 mb-1">{{nameBranch}}</p>
        </div>
        <div class="d-flex me-1">
          <label class="form-label me-1 style-text">Empresa:</label>
          <p class="mb-lg-2 mb-1">{{nameEnterprise}}</p>
        </div>
        <div class="d-flex me-1" *ngIf="electronicInvoiceInterfaceContract.consecutive != 0">
          <label class="form-label me-1 style-text">Interfaz</label>
          <p class="mb-lg-2 mb-1">{{electronicInvoiceInterfaceContract.consecutive}}</p>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="startProcess" class="row mt-2 container-style">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 ">
      <div *ngIf="visibleAlerts; else load">
        <p class="mb-2"><b class="style-text">Lista de Errores y Alertas</b></p>
        <hr class="my-2">
        <div *ngFor="let preInvoicingAlert of preInvoicingAlerts" class="ms-2">
          <p [ngClass]="preInvoicingAlert.alertType == 1 ? 'text-danger' : ''" style="white-space: pre-line;">
            {{preInvoicingAlert.message}}
          </p>
        </div>
      </div>
      <ng-template #load>
        <p class="mb-2"><b class="style-text">{{mainText}}</b></p>
        <app-custom-progress-bar [show]="true" [heightProgress]="'0.8rem'"></app-custom-progress-bar>
      </ng-template>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end gap-2 ">
      <app-custom-button [title]="'Iniciar'" [label]="'Iniciar'" (onClick)="syncUp()" [severity]="'primary'"
        [width]="'5rem'" [variant]="undefined" [disabled]="disabledStart"></app-custom-button>

      <app-custom-button [title]="'Salir'" [label]="'Salir'" (onClick)="cancel()" [severity]="'danger'"
        [width]="'5rem'"></app-custom-button>
    </div>
  </div>
</section>
<app-custom-modal #pendingSyncDocumentModal [header]="'Documentos'" [width]="'55vw'"
  [children]="componentPendingSyncDocument" [inputs$]="inputsForPendingSyncDocumentModal$" [output$]="output$"
  (onRecoverData)="getPendingSyncDocumentsWithPagination()" (params)="getElectronicDocuments()" hidden>
</app-custom-modal>